import { ComponentPropsWithoutRef } from 'react';

import { Box } from '@occc-app/design-system';
import { InfoBox, Typography } from '@occc/ui-design-system';

export const MultipleEnabledBanner = (props: ComponentPropsWithoutRef<typeof Box>) => {
  return (
    <Box {...props}>
      <InfoBox>
        <Typography color='primary.dark' variant='body2'>
          When both Push and SMS are enabled, Push is sent to members opted in to Push; SMS is sent
          to others.
        </Typography>
      </InfoBox>
    </Box>
  );
};
